import React from "react";
import Footer from "./component5/Footer";
import Header from "./component5/Header/Header";
import HomeScreen from "./component5/Body/HomeScreen";

function App() {
  return (
    <div>
      <Header />
      <HomeScreen />
      <Footer />
    </div>
  );
}

export default App;
